import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=3fb6b81b&scoped=true&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetails.vue?vue&type=style&index=0&id=3fb6b81b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb6b81b",
  null
  
)

export default component.exports